import styled from "styled-components";

export const DetailSection = styled.section`
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 2px solid var(--border-subtle);
  border-radius: 16px;
  padding: 2rem;
  width: 100%;
  max-width: 600px;
  margin: 1rem auto 0;
  align-self: center;
  box-sizing: border-box;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--accent-secondary-soft);

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.span`
  color: var(--text-heading);
  font-weight: 500;
  min-width: 140px;
`;

export const DetailValue = styled.span`
  color: var(--accent-secondary);
  font-family: monospace;
  word-break: break-all;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;
